var _path, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNounPoweroff108691(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3,23.2l-3.5,3.5C14.2,34.3,10,44.3,10,55s4.2,20.7,11.7,28.3C29.5,91.1,39.8,95,50,95c10.2,0,20.5-3.9,28.3-11.7  C85.8,75.7,90,65.7,90,55s-4.2-20.7-11.7-28.3l-3.5-3.5l-7.1,7.1l0,0l3.5,3.5C76.9,39.5,80,47,80,55s-3.1,15.5-8.8,21.2  c-11.7,11.7-30.7,11.7-42.4,0C23.1,70.6,20,63,20,55s3.1-15.5,8.8-21.2l3.5-3.5l0,0L25.3,23.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "55,45 55,30.3 55,5 45,5 45,30.3 45,45 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounPoweroff108691);
export default __webpack_public_path__ + "static/media/noun_power off_108691.139517b6.svg";
export { ForwardRef as ReactComponent };